import { calcOreDillution } from "../../calculations/oreDillution";
import { reactStates, useFile } from "../../context/filecontext";
import { loadGltfCustom } from "../../utils/loaders/gltfLoader/gltfLoaderCustom";
import { manager } from "../fileviewer";
import { complexCSG } from "./csg/complexCSG";
import * as THREE from "three";
import {
  Brush,
  Evaluator,
  ADDITION,
  SUBTRACTION,
  REVERSE_SUBTRACTION,
  INTERSECTION,
  DIFFERENCE,
  HOLLOW_SUBTRACTION,
  HOLLOW_INTERSECTION,
  computeMeshVolume,
} from "three-bvh-csg";

export class GetOreDillution {
  constructor(params) {
    this.designLasUrl = params.designLasUrl;
    this.actualLasUrl = params.actualLasUrl;
    this.scene = manager.pViewer.scene.scene;
    this.states = params.states;
    window.getOreDillution = this;
    this.baseUrl = process.env.REACT_APP_BACKEND_URL;
  }

  init() {
    let volumeData = this.getOverBreakUnderBreakVolume();
    return volumeData;
  }

  async getOverBreakUnderBreakVolume() {
    let scope = this;
    // reactStates.current.showNotificationWithConfig({message : "Over Break and Under Break Volume", type : "info"});
    await reactStates.current.showLoader("Over Break and Under Break Volume");
    let backendData = await this.callApi();
    if (backendData.message === "error") {
      reactStates.current.showNotificationWithConfig({
        message: backendData.data.error,
        type: "error",
      });
      reactStates.current.removeLoader();
      return;
    }
    let volumeData = backendData.data;
    // let m = new THREE.Mesh(new THREE.BufferGeometry(), new THREE.MeshBasicMaterial())
    // this.operations = await complexCSG(this);
    // let volumeData = this.getVolumeData();
    // let volumeData = {'overBreakUrl': 'http://127.0.0.1:8000/generated_files/mesh_1467/csg/csg1.glb', 'overBreakVolume': 454.3525750703023, 'underBreakUrl': 'http://127.0.0.1:8000/generated_files/mesh_1467/csg/csg2.glb', 'underBreakVolume': 271.5239956629618}
    this.volumeDataResponse = volumeData;

    this.overBreakUrl = decodeURIComponent(volumeData.overBreakUrl);
    this.underBreakUrl = decodeURIComponent(volumeData.underBreakUrl);
    console.log(this.overBreakUrl);
    console.log(this.underBreakUrl);
    // let volumeData = {'overBreakUrl': 'http://127.0.0.1:8000/generated_files/mesh_1467/csg/csg1.glb', 'overBreakVolume': 454.3525750703023, 'underBreakUrl': 'http://127.0.0.1:8000/generated_files/mesh_1467/csg/csg2.glb', 'underBreakVolume': 271.5239956629618}

    // this.actualVolume = volumeData.actualVolume;
    // this.designVolume = volumeData.designVolume;
    this.overBreakVolume = volumeData.overBreakVolume;
    this.underBreakVolume = volumeData.underBreakVolume;

    await this.loadGlbs();

    reactStates.current.removeLoader();
    reactStates.current.showNotificationWithConfig({
      message: "Calculated Over Break and Under Break volume",
      type: "info",
    });

    this.updateDom();
  }
  getVolumeData() {
    new Promise((resolve, reject) => {
      this.lasUrl1 =
        "https://chatgpt.com/c/67c53b61-f7a8-800b-8f87-e7972d8cfc33";
      this.lasUrl2 =
        "https://chatgpt.com/c/67c53b61-f7a8-800b-8f87-e7972d8cfc33";
      let postData = {
        las_url1: this.lasUrl1,
        las_url2: this.lasUrl2,
      };

      fetch("http://127.0.0.1:8000/get-volume-data/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(postData),
      })
        .then((response) => response.json())
        .then((data) => {
          console.log("Success:", data);

          resolve(data);
        })
        .catch((error) => console.error("Error:", error));
    });
  }

  async loadGlbs() {
    let oGlbData = await loadGltfCustom(this.overBreakUrl);
    let uGlbData = await loadGltfCustom(this.underBreakUrl);
    let oObj = oGlbData.scene;
    let uObj = uGlbData.scene;
    oObj.name = "overBreak";
    uObj.name = "underBreak";
    this.scene.add(oGlbData.scene);
    this.scene.add(uGlbData.scene);
    this.addLighting(oObj);
    this.changeColor(oObj, "#ec6262");
    this.changeColor(uObj, "#e1d276");
  }

  async getOverBreakUnderBreakVolume2() {
    // reactStates.current.showNotificationWithConfig({message : "Over Break and Under Break Volume", type : "info"});
    await reactStates.current.showLoader("Over Break and Under Break Volume");

    let m = new THREE.Mesh(
      new THREE.BufferGeometry(),
      new THREE.MeshBasicMaterial()
    );
    this.operations = await complexCSG(this);
    this.scene.add(this.operations.gltf.scene);
    this.scene.add(this.operations.gltf2.scene);
    this.operations.properties.operation = SUBTRACTION;

    await reactStates.current.showLoader("Calculating Over Break");

    // reactStates.current.showNotificationWithConfig({message : "Calculating Over Break", type : "info"});
    this.rSubtractionData = this.operations.doOperation(
      new THREE.Mesh(
        new THREE.BufferGeometry(),
        new THREE.MeshBasicMaterial({
          color: "red",
          opacity: 1,
          transparent: true,
        })
      ),
      REVERSE_SUBTRACTION
    );

    await reactStates.current.showLoader("Calculating Under Break");

    // reactStates.current.showNotificationWithConfig({message : "Calculating Under Break", type : "info"});
    this.subtractionData = this.operations.doOperation(
      new THREE.Mesh(
        new THREE.BufferGeometry(),
        new THREE.MeshBasicMaterial({
          color: "green",
          opacity: 1,
          transparent: true,
        })
      ),
      SUBTRACTION
    );

    this.sObj = this.subtractionData.output;
    this.sObj.material[0]?.color.set("green");

    this.sObj.material[0].opacity = 1;
    this.sObj.material[1].opacity = 1;
    this.sObj.name = "overBreak";

    this.operations.properties.operation = REVERSE_SUBTRACTION;
    this.rSObj = this.rSubtractionData.output;
    this.rSObj.material[0]?.color.set("red");
    this.rSObj.material[0].opacity = 1;
    this.rSObj.name = "underBreak";

    this.scene.add(this.sObj);
    this.scene.add(this.rSObj);
    reactStates.current.removeLoader();
    reactStates.current.showNotificationWithConfig({
      message: "Calculated Over Break and Under Break volume",
      type: "info",
    });

    this.updateDom();
  }

  updateDom() {
    debugger;
    let states = reactStates.current;
    let aVolume = states.uploadResponseData?.volume;
    console.log(aVolume);
    let oBVolume = this.overBreakVolume;
    let uBVolume = this.underBreakVolume;
    let Volume = window.designVolume;
    let overBreakPercentage = (oBVolume * 100) / aVolume;
    let underBreakPercentage = (uBVolume * 100) / aVolume;
    let oreDillutionValue = calcOreDillution(aVolume, Volume, uBVolume);
    console.log(oreDillutionValue, "vv");
    let newMeasurements = {
      ...states.currentMeasurements,
      volume: { totalVolume: 0, surfaceArea: 0 },
      overbreak: {
        volume: oBVolume,
        percentage: overBreakPercentage,
        maxLength: 1.5,
      },
      underbreak: {
        volume: uBVolume,
        percentage: underBreakPercentage,
        maxLength: 0.76,
      },
      density: { pointDensity: 0, coverage: 0 },
      plannedDesignVolume: {
        volume: window.designVolume,
      },
      oreDillution: oreDillutionValue,
    };
    states.setCurrentMeasurements(newMeasurements);
    localStorage.setItem("scanresult", JSON.stringify(newMeasurements));
  }

  changeColor2(obj, color) {
    obj.material.forEach((m) => {
      m.color.set(color);
    });
  }

  changeColor(obj, color = "red") {
    if (!obj) {
      console.warn("Object not found");
      return;
    }

    obj.traverse((child) => {
      if (child instanceof THREE.Mesh) {
        if (child.material) {
          console.log("materias;");
          // Ensure material is not an array
          if (Array.isArray(child.material)) {
            child.material.forEach((mat) => {
              if (mat.color) mat.color.set(color);
              mat.needsUpdate = true;
            });
          } else {
            if (child.material.color) child.material.color.set(color);
            child.material.needsUpdate = true;
          }
        }
      }
    });
  }

  // Function to add lights dynamically based on object size
  addLighting(obj) {
    const scene = obj.parent; // Ensure we add light to the correct scene

    if (!scene) {
      console.warn("Object is not part of any scene.");
      return;
    }

    // Remove existing lights if needed (to avoid duplicates)
    const existingLights = scene.children.filter((child) => child.isLight);
    existingLights.forEach((light) => scene.remove(light));

    // Compute the object's bounding box
    const box = new THREE.Box3().setFromObject(obj);
    const size = box.getSize(new THREE.Vector3()); // Get object dimensions
    const center = box.getCenter(new THREE.Vector3()); // Get object center

    // Define light distance (slightly larger than object size)
    const offset = Math.max(size.x, size.y, size.z) * 1.5;

    // Ambient Light for soft global illumination
    const ambientLight = new THREE.AmbientLight(0xffffff, 0.4);
    scene.add(ambientLight);

    // Dynamic point lights around the object
    const lightPositions = [
      { x: offset, y: offset, z: offset }, // Top-Right-Front
      { x: -offset, y: offset, z: offset }, // Top-Left-Front
      { x: offset, y: -offset, z: offset }, // Bottom-Right-Front
      { x: -offset, y: -offset, z: offset }, // Bottom-Left-Front
      { x: offset, y: offset, z: -offset }, // Top-Right-Back
      { x: -offset, y: offset, z: -offset }, // Top-Left-Back
      { x: offset, y: -offset, z: -offset }, // Bottom-Right-Back
      { x: -offset, y: -offset, z: -offset }, // Bottom-Left-Back
    ];

    lightPositions.forEach((pos) => {
      const pointLight = new THREE.PointLight(0xffffff, 0.8);
      pointLight.position.set(
        center.x + pos.x,
        center.y + pos.y,
        center.z + pos.z
      );
      scene.add(pointLight);
    });
  }

  sendError(e) {
    return {
      message: "error",
      data: {
        error: e,
      },
    };
  }

  async callApi() {
    let postData = {
      las_url1: reactStates.actualMetadataUrl,
      las_url2: reactStates.designMetadataUrl,
    };
    // let postfuploaData = {
    //     "las_url1": "https://private-bucket-mine.s3.ap-south-1.amazonaws.com/stope-recovery/123-1/1-2025_02_28-05_53_42/actual/postProcess/metadata.json",
    //     "las_url2": "https://private-bucket-mine.s3.ap-south-1.amazonaws.com/Files/c3VzaGls/flat-design/postprocessfiles/lasFile/metadata.json"
    // }

    try {
      // const response = await fetch(this.baseUrl + "/get-volume-data/", {
      const response = await fetch(this.baseUrl + "/get-volume-data/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(postData),
      });

      if (!response.body) throw new Error("Response body is null");

      const reader = response.body.getReader();
      const decoder = new TextDecoder();

      while (true) {
        const { value, done } = await reader.read();
        if (done) break;

        let data = decoder.decode(value);
        console.log(data);

        try {
          let jData = JSON.parse(data);
          if (!jData.message) {
            if (jData.detail) {
              let msg = jData.detail[0]?.msg;
              if (msg) {
                return {
                  message: "error",
                  data: {
                    error: msg,
                  },
                };
              }
            }
          }
          if (jData.message === "success") {
            return jData;
          } else if (jData.message === "error") {
            return jData;
          } else {
            await reactStates.current.showLoader(jData.message);
          }
        } catch (error) {
          console.error("Error parsing JSON:", error);
        }
      }

      console.log("Streaming finished.");
    } catch (error) {
      console.error("API call failed:", error);
      return {
        message: "error",
        data: {
          error: "Something went wrong in server",
        },
      };
    }
  }
  updateDom2() {
    let states = reactStates.current;

    let aVolume = states.uploadResponseData?.volume;
    console.log(aVolume);
    let overBreakPercentage = (this.subtractionData.volume * 100) / aVolume;
    let underBreakPercentage = (this.rSubtractionData.volume * 100) / aVolume;

    let overbreak = states.currentMeasurements.overbreak;
    let underbreak = states.currentMeasurements.underbreak;
    overbreak.volume = 5;
    underbreak.volume = 6;
    let newMeasurements = {
      ...states.currentMeasurements,
      volume: { totalVolume: 0, surfaceArea: 0 },
      overbreak: {
        volume: this.subtractionData.volume,
        percentage: overBreakPercentage,
        maxLength: 1.5,
      },
      underbreak: {
        volume: this.rSubtractionData.volume,
        percentage: underBreakPercentage,
        maxLength: 0.76,
      },
      density: { pointDensity: 0, coverage: 0 },
      plannedDesignVolume: {
        volume: window.designVolume,
      },
    };
    states.setCurrentMeasurements(newMeasurements);
    localStorage.setItem("scanresult", JSON.stringify(newMeasurements));
  }
}
